import React, { useEffect, useState } from "react";
import Faq from "react-faq-component";
import About from "../assests/qac4.jpg";

const data = {
  title: "Frequently Asked Questions? ",
  rows: [
    {
      title: "Where is Qhubeka located?",
      content: `Qhubeka is headquartered in Elspark, Germiston, with training teams based in various locations across the East Rand.`,
    },
    {
      title: "Where do you train?",
      content:
        "You don’t need to be a member to train with us! We have daily group runs at 04:45 AM from the following locations: Monday, Tuesday, Wednesday, Friday, and Sunday: Sunward Park Shell Garage. Tuesday at 04:45 AM: Astron Garage in Faraar Park. Saturday at 05:00 AM: Weekly long runs from Meadowdale Shopping Center in Edenvale",
    },
    {
      title: "How can I become a member?",
      content: `Becoming a member is simple! Just fill out our online registration form, and we'll get in touch with you. Alternatively, you can email us at admin@qhubekaac.co.za for more information.`,
    },
    {
      title: "Do you have training plans?",
      content: `Yes, we do. Our club coach, Benzi Tenza, shares training plans on a weekly basis. `,
    },
    {
      title: "Do you offer individual coaching",
      content: `Yes, we do. Our club coach, Benzi Tenza, offers individual training sessions for members who are interested `,
    },
  ],
};

const styles = {
  bgColor: "white",
  titleTextColor: "blue",
  rowTitleColor: "blue",
  rowContentPaddingLeft: "50px",
  rowContentColor: "red",
  // arrowColor: "red",
};

const config = {
  animate: true,
  //arrowIcon: "V",
  openOnload: 10,
  expandIcon: "+",
  collapseIcon: "-",
};

const FAQ = () => {
  return (
    <>
      <div className=" font-bold  bg-white bg-cover w-full ">
        <div className="pt-40 pb-16 px-5 md:px-40">
          <Faq data={data} styles={styles} config={config} />
        </div>
      </div>
    </>
  );
};

export default FAQ;
